import { render, staticRenderFns } from "./NdRamHistory.vue?vue&type=template&id=7c668de2"
import script from "./NdRamHistory.vue?vue&type=script&lang=js"
export * from "./NdRamHistory.vue?vue&type=script&lang=js"
import style0 from "./NdRamHistory.vue?vue&type=style&index=0&id=7c668de2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports